// Generic Supabase upsert/soft-delete helpers. Bind via .call('upsertRow', ...)
// from any DOMQL element so the active fetch context (config.fetch) is reused.

const _logErr = (scope, err) => console.error(`[${scope}]`, err?.message || err)

const OPTIMISTIC_ID_FLOOR = 1_000_000_000_000
export const isOptimisticId = (id) => typeof id !== 'number' || id >= OPTIMISTIC_ID_FLOOR

export const upsertRow = async function ({ from, row }) {
  const fetch = this.context?.fetch
  if (!fetch?.upsert) { _logErr('upsertRow', 'context.fetch.upsert missing'); return null }
  const data = isOptimisticId(row?.id) ? { ...row, id: undefined } : row
  try {
    const result = await fetch.upsert({ from, data })
    if (result?.error) { _logErr('upsertRow', result.error); return null }
    return result?.data?.[0]?.id ?? null
  } catch (e) { _logErr('upsertRow', e); return null }
}

export const softDeleteRow = async function ({ from, id }) {
  if (isOptimisticId(id)) return true
  const fetch = this.context?.fetch
  if (!fetch?.update) { _logErr('softDeleteRow', 'context.fetch.update missing'); return false }
  try {
    const result = await fetch.update({
      from,
      params: { id },
      data: { deleted: true, dirty: true, updated_at: new Date().toISOString() }
    })
    if (result?.error) { _logErr('softDeleteRow', result.error); return false }
    return true
  } catch (e) { _logErr('softDeleteRow', e); return false }
}
